import {
    StyleSheet
} from "react-native";
import {
    windowWidth
} from "../../utils";

const stylesheet = StyleSheet.create({
    container: {
        transformOrigin: "bottom",
        position: "absolute",
        zIndex: 99999,
        bottom: 0,
        right: 0,
        left: 0
    },
    handleContainer: {
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 0,
        left: 0
    },
    handle: {
        width: windowWidth / 10
    }
});
export default stylesheet;
